<template>
    <div class="clients">
        <!-- Cabeçalho -->
        <header class="clients-header">
            <div></div>      
            <!-- Botão para alternar entre tabela e kanban -->
            <el-button @click="handleModalFormClient()" type="success" icon="Plus">
                Perfil
            </el-button>
        </header>
        <!-- Tabela de Tarefas -->
        <el-table :data="categories" style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="Perfil" />                
            
            <el-table-column label="Ações">
              <template #default="scope">
                <el-button
                  icon="Edit"
                  type="success"
                  v-if="scope.row.slug !== 'admin'"
                  plain
                  @click="editClient(scope.row)" />
                <el-button                  
                  type="danger" 
                  icon="Delete"
                  v-if="scope.row.slug !== 'admin'"
                  plain
                  @click="deleteData(scope.row)" />                  
              </template>
            </el-table-column>
          </el-table>     
          
          <el-dialog v-model="isModalVisible" :title="titleModal">
              <el-form label-position="top" :model="dataForm">
    
                  <el-input hidden v-model="dataForm.id" />                  
    
                  <el-form-item label="Nome do perfil">
                      <el-input v-model="dataForm.name" />
                  </el-form-item>
                  
              </el-form>
              <div>
                  <el-button @click="isModalVisible = false">Cancelar</el-button>
                  <el-button type="primary" @click="saveData()">Salvar</el-button>
              </div>
          </el-dialog>    
    </div>
</template>
<script>
import { ElMessageBox, ElNotification } from 'element-plus';
import { deleteCategory, getCategories, storeCategory, updateCategory } from '@/services/userService';

export default {
    name: "SettingsUserCategories",    
    data() {
        return {
            urlApi: process.env.VUE_APP_API_URL,
            categories: [],
            dataForm: {
                id: null,
                name: '',
            },
            loading: false,
            isModalVisible: false,
            titleModal: 'Cadastrar Perfil',
            actionForm: 'create'
        };
    },    
    methods: {
        async getData() {
            this.loading = true;
            try {
                const response = await getCategories();                

                this.categories = response.data;
            } catch (error) {
                this.$message.error("Erro ao carregar categorias de tarefas.");
            } finally {
                this.loading = false;
            }
        },
        handleModalFormClient() {       
            this.isModalVisible = true;
            this.actionForm = 'create';
            this.titleModal = 'Cadastrar Perfil';
            this.resetForm();
        },
        editClient(client) {
            this.handleModalFormClient();

            this.dataForm = {
                id: client.id,
                name: client.name,
                active: String(client.active)
            }

            this.titleModal = 'Atualizar Perfil';
            this.actionForm = 'update';
        },

        async saveData() {
            this.loading = true;
            this.errors = {};
            try {
                if (this.actionForm == 'create') {
                    await storeCategory(this.dataForm);

                    ElNotification({
                        title: 'Atenção!',
                        message: 'Registro criado com sucesso.',
                        type: 'success'
                    });
                }

                if (this.actionForm == 'update') {
                    await updateCategory(this.dataForm);
                    ElNotification({
                        title: 'Atenção!',
                        message: 'Registro salvo com sucesso.',
                        type: 'success'
                    });
                }
                
            } catch (error) {
                console.log('error ===> ', error)
                if (error.errors) {
                    const errors = error.errors;
                    const errorMessages = Object.values(errors)
                        .flat()
                        .join('\n');

                        ElNotification({
                            title: 'Erro de Validação',
                            message: errorMessages,
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                        });
                } else {
                    ElNotification({
                        title: 'Erro!',
                        message: 'Ocorreu um erro inesperado ao processar a solicitação.',
                        type: 'error',
                    });
                }

            } finally {
                this.resetForm();
                this.getData();

                this.isModalVisible = false;
                this.loading = false;
            }
        },

        async deleteData(category){

            await ElMessageBox.confirm(
                'Deseja realmente deletar este registro: '+ category.name +'?',
                'Warning',
                {
                    confirmButtonText: 'Confirmar Exclusão',
                    cancelButtonText: 'Cancelar',
                    type: 'warning',
                }
            )
            .then(() => {
                this.loading = true;
                
                deleteCategory(category.id);                                
                this.getData();
                ElNotification({
                    title: 'Atenção!',
                    message: 'Registro deletado com sucesso.',
                    type: 'success'
                });

            })
            .catch(() => {
                
            });

            this.getData();
            this.loading = false;
        },

        resetForm() {
            this.dataForm = {
                id: null,
                name: ''
            }
        }
    },
    mounted() {
        this.getData();  
    },
};
</script>

<style scoped>
.clients-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.clients-header h2 {
    font-size: 24px;
    margin: 0;
}
.notification-icon {
    cursor: pointer;
}
</style>
    